// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
// Actions
import {ConfigDebtActions, ConfigDebtActionTypes} from '../_actions/config-debt.actions';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
import {ConfigDebt} from '..';

// Models

export interface ConfigDebtState extends EntityState<ConfigDebt> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastQuery: QueryParamsModel;
	lastCreatedConfigDebtId: number;
	showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<ConfigDebt> = createEntityAdapter<ConfigDebt>();

export const initialConfigDebtState: ConfigDebtState = adapter.getInitialState({
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastQuery: new QueryParamsModel({}),
	lastCreatedConfigDebtId: undefined,
	showInitWaitingMessage: true
});

export function configDebtReducer(state = initialConfigDebtState, action: ConfigDebtActions): ConfigDebtState {
	switch (action.type) {
		case ConfigDebtActionTypes.ConfigDebtsPageToggleLoading:
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedConfigDebtId: undefined
			};
		case ConfigDebtActionTypes.ConfigDebtsActionToggleLoading:
			return {
				...state, actionsloading: action.payload.isLoading
			};
		case ConfigDebtActionTypes.ConfigDebtOnServerCreated:
			return {
				...state
			};
		// case ConfigDebtActionTypes.ConfigDebtCreated:
		// 	return adapter.addOne(action.payload.ConfigDebt, {
		// 		...state, lastCreatedConfigDebtId: action.payload.product.id
		// 	});
		case ConfigDebtActionTypes.ConfigDebtUpdated:
			return adapter.updateOne(action.payload.partialConfigDebt, state);
		// case ConfigDebtActionTypes.ConfigDebtStatusUpdated: {
		// 	const _partialConfigDebt: Update<ConfigDebt>[] = [];
		// 	for (let i = 0; i < action.payload.ConfigDebt.length; i++) {
		// 		_partialConfigDebt.push({
		// 			id: action.payload.ConfigDebt[i].id,
		// 			changes: {
		// 				status: action.payload.status
		// 			}
		// 		});
		// 	}
		// 	return adapter.updateMany(_partialConfigDebt, state);
		// }
		case ConfigDebtActionTypes.OneConfigDebtDeleted:
			return adapter.removeOne(action.payload.id, state);
		case ConfigDebtActionTypes.ManyConfigDebtsDeleted:
			return adapter.removeMany(action.payload.ids, state);
		case ConfigDebtActionTypes.ConfigDebtsPageCancelled:
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		case ConfigDebtActionTypes.ConfigDebtsPageLoaded:
			return adapter.addMany(action.payload.ConfigDebts, {
				...initialConfigDebtState,
				totalCount: action.payload.totalCount,
				listLoading: false,
				lastQuery: action.payload.page,
				showInitWaitingMessage: false
			});
		default:
			return state;
	}
}

export const getConfigDebttate = createFeatureSelector<ConfigDebt>('configDebt');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
